import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Avatar,
  Grid,
  Chip,
  Container,
  Paper,
} from "@mui/material";
import { providers } from "./data";

const ProvidersModels = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography
        sx={{
          color: "#002367",
          fontFamily: "Light",
          fontSize: { xs: 28, sm: 36, md: 42 }, // Responsive font size
          fontWeight: "700",
          lineHeight: "35px",
          textAlign: "center",
          marginTop: { xs: 6, sm: 2, md: 2, lg: 3, xl: 3 },
          marginBottom: { xs: 5, sm: 4, md: 4, lg: 6, xl: 6 },
        }}
      >
        Supported AI Model Providers
      </Typography>
      <Paper
        elevation={3}
        sx={{ p: 2, mb: 4, backgroundColor: "#FFFFFF", borderRadius: 2 }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "#002367",
            fontFamily: "Light",
            fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
            textAlign: "center", // Center-align text on all screens
          }}
        >
          <strong>Model Implementation Status:</strong> Continuously updating
          our supported models
        </Typography>
      </Paper>
      <Grid container spacing={3} justifyContent="center">
        {providers.map((provider, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card
              sx={{
                transition: "0.3s",
                "&:hover": { transform: "translateY(-5px)" },
                borderRadius: 2,
                border: "1px solid rgba(56, 55, 55, 0.2)",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                "&:hover": { boxShadow: "2px 6px 25px rgba(0,0,0,0.15)" },
                p: 2,
                height: 350, // Fixed height for all cards
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardHeader
                avatar={
                  <Avatar
                    src={provider.logoUrl}
                    alt={provider.name}
                    sx={{
                      maxWidth: "100%",
                      width: 60,
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                }
                title={
                  <Typography
                    sx={{
                      color: "#002367",
                      fontFamily: "Light",
                      fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
                      textAlign: "start", // Center-align text on all screens
                      fontWeight: "bold",
                    }}
                  >
                    {provider.name}
                  </Typography>
                }
                subheader={
                  <Typography
                    sx={{
                      color: "#7e7f80",
                      fontFamily: "Light",
                      fontSize: { xs: 10, sm: 10, md: 12, lg: 14, xl: 14 }, // Responsive font size
                      textAlign: "start", // Center-align text on all screens
                    }}
                  >
                    {`${
                      provider.models.length || provider.unimplemented.length
                    } Models`}
                  </Typography>
                }
              />
              <CardContent sx={{ flexGrow: 1, overflowY: "auto" }}>
                {provider.models.map((model, mIndex) => (
                  <Chip
                    key={mIndex}
                    label={
                      <Typography
                        sx={{
                          color: "#000000",
                          fontFamily: "Light",
                          fontSize: { xs: 10, sm: 10, md: 12, lg: 14, xl: 14 }, // Responsive font size
                          textAlign: "start", // Center-align text on all screens
                        }}
                      >
                        {model}
                      </Typography>
                    }
                    variant="outlined"
                    sx={{ m: 0.5, backgroundColor: "#f8f8f8" }}
                  />
                ))}
                {provider.thirdParty.length > 0 && (
                  <Typography
                    sx={{
                      color: "#002367",
                      fontFamily: "Light",
                      fontSize: { xs: 10, sm: 10, md: 12, lg: 14, xl: 14 }, // Responsive font size
                      textAlign: "start", // Center-align text on all screens
                      fontWeight: "bold",
                      marginBottom: 0.5,
                      pl: 0.5,
                      marginTop: 1,
                    }}
                  >
                    {"Third Party Models"}
                  </Typography>
                )}
                {provider.thirdParty.map((model, mIndex) => (
                  <Chip
                    key={mIndex}
                    label={
                      <Typography
                        sx={{
                          color: "#000000",
                          fontFamily: "Light",
                          fontSize: { xs: 10, sm: 10, md: 12, lg: 14, xl: 14 }, // Responsive font size
                          textAlign: "start", // Center-align text on all screens
                        }}
                      >
                        {model}
                      </Typography>
                    }
                    variant="outlined"
                    sx={{ m: 0.5, backgroundColor: "#defdf9" }}
                  />
                ))}
                {provider.unimplemented.length > 0 && (
                  <Typography
                    sx={{
                      color: "#002367",
                      fontFamily: "Light",
                      fontSize: { xs: 10, sm: 10, md: 12, lg: 14, xl: 14 }, // Responsive font size
                      textAlign: "start", // Center-align text on all screens
                      fontWeight: "bold",
                      marginBottom: 0.5,
                      pl: 0.5,
                    }}
                  >
                    {"Coming Soon"}
                  </Typography>
                )}
                {provider.unimplemented.map((model, mIndex) => (
                  <Chip
                    key={mIndex}
                    label={
                      <Typography
                        sx={{
                          color: "#000000",
                          fontFamily: "Light",
                          fontSize: { xs: 10, sm: 10, md: 12, lg: 14, xl: 14 }, // Responsive font size
                          textAlign: "start", // Center-align text on all screens
                        }}
                      >
                        {model}
                      </Typography>
                    }
                    variant="outlined"
                    sx={{ m: 0.5, backgroundColor: "#defdf9" }}
                  />
                ))}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box mt={4} textAlign="center">
        <Typography
          variant="body2"
          sx={{
            color: "#002367",
            fontFamily: "Light",
            fontSize: { xs: 12, sm: 12, md: 14, lg: 16, xl: 18 }, // Responsive font size
            textAlign: "center", // Center-align text on all screens
          }}
        >
          Model support information current as of March 2025. New models are
          continuously being added.
        </Typography>
      </Box>
    </Container>
  );
};

export default ProvidersModels;
